var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import get from 'lodash/get';
import { getItem } from 'conversional-persistent-storage';
import { addStylesToRootLauncher, appendChild, appendToRoot, createElement, getRootLauncher } from './utils';
import { addCloseIcon, LAUNCHER_HIDE_KEY } from './general';
import { getLauncherFontFamily } from './textLauncher';
var CALENDAR_ICON = '<svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19 4h-1V2h-2v2H8V2H6v2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 16H5V9h14v11z"/></svg>';
var ARROW_ICON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
export var renderButtonLauncher = function (loader, theme) {
    appendToRoot(createButtonLauncherContainer(loader, theme));
};
export function createButtonLauncherContainer(loader, theme) {
    // Rendered after the journey's launcher delay: the launcher may be gone by then (a journey switch)
    if (!getRootLauncher())
        return null;
    var fontFamily = getLauncherFontFamily(loader, theme);
    addStylesToRootLauncher(__assign({ height: 'auto' }, (fontFamily ? { fontFamily: fontFamily } : {})));
    var container = createElement({
        uniqueId: 'button-launcher-container',
        styles: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            height: '48px',
            padding: '0 16px',
            boxSizing: 'border-box',
            whiteSpace: 'nowrap',
            fontSize: '15px',
            fontWeight: 600,
            background: loader.backgroundColor || get(theme, 'colors.brand'),
            color: loader.textColor || get(theme, 'colors.textOnBrand'),
            borderRadius: loader.borderRadius || '6px',
            boxShadow: loader.boxShadow || '0 4px 14px rgba(0, 0, 0, 0.18)',
        },
    });
    if (!container)
        return null;
    if (getItem(LAUNCHER_HIDE_KEY))
        getRootLauncher().style.display = 'none';
    var closable = loader.closable, reloadOnClose = loader.reloadOnClose;
    closable && addCloseIcon(container, { reloadOnClose: reloadOnClose, styles: { top: '-10px !important', right: '-10px !important' } });
    loader.icon !== 'none' && appendChild(container, createElement({ tagName: 'span', styles: { display: 'flex' }, innerHTML: CALENDAR_ICON }));
    var label = createElement({ tagName: 'span' });
    label.textContent = loader.text;
    appendChild(container, label);
    loader.showArrow !== false && appendChild(container, createElement({ tagName: 'span', styles: { display: 'flex' }, innerHTML: ARROW_ICON }));
    return container;
}
